// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"979b0a85","300":"6bf56e7c","488":"37cec2e0","530":"1521fc99"}[chunkId] + ".chunk.js";
};